
// WhyChooseUs.js

import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FiFileText,
  FiUsers,
  FiAward,
  FiCheckCircle
} from "react-icons/fi";


const fadeUp = keyframes`

from{
opacity:0;
transform:translateY(35px);
}

to{
opacity:1;
transform:translateY(0);
}

`;



const SectionWrapper = styled.section`

padding:6rem 1.5rem;


background:

linear-gradient(
180deg,
${({theme})=>theme.colors.bgAccent},
${({theme})=>theme.colors.white}
);


border-top:1px solid ${({theme})=>theme.colors.border};

border-bottom:1px solid ${({theme})=>theme.colors.border};

`;



const Container = styled.div`

max-width:1280px;

margin:auto;

`;



const HeaderContainer = styled.div`

max-width:750px;

margin:0 auto 4rem;


text-align:center;

`;



const SectionBadge = styled.div`

display:inline-flex;

align-items:center;

justify-content:center;


padding:.45rem 1.2rem;


border-radius:50px;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


font-size:.8rem;


font-weight:800;


letter-spacing:.1em;


text-transform:uppercase;


margin-bottom:1rem;

`;



const SectionTitle = styled.h2`

font-size:clamp(2rem,4vw,3rem);


font-weight:800;


line-height:1.15;


letter-spacing:-1px;


color:${({theme})=>theme.colors.textDark};


margin-bottom:1rem;

`;



const SectionSubtitle = styled.p`

font-size:1.05rem;


line-height:1.7;


color:${({theme})=>theme.colors.textMuted};


`;





const Grid = styled.div`

display:grid;


grid-template-columns:repeat(3,1fr);


gap:2rem;



@media(max-width:${({theme})=>theme.breakpoints.desktop}){

grid-template-columns:1fr;

}


`;




const FeatureCard = styled.div`

position:relative;


padding:2.5rem 2rem;


background:${({theme})=>theme.colors.white};


border-radius:24px;


border:1px solid ${({theme})=>theme.colors.border};


box-shadow:

0 10px 30px rgba(15,23,42,.06);


overflow:hidden;


transition:${({theme})=>theme.transitions.default};


animation:${fadeUp}.7s ease both;



&::before{

content:"";

position:absolute;


top:0;

left:0;


width:100%;


height:5px;


background:

linear-gradient(
90deg,
${({theme})=>theme.colors.primary},
${({theme})=>theme.colors.secondary}
);


transform:scaleX(0);


transform-origin:left;


transition:.4s;

}



&:hover{

transform:translateY(-10px);


box-shadow:

0 25px 50px rgba(15,23,42,.12);

}



&:hover::before{

transform:scaleX(1);

}



`;





const IconWrapper = styled.div`

width:70px;

height:70px;


display:flex;

align-items:center;

justify-content:center;


border-radius:20px;


background:

linear-gradient(
135deg,
${({theme})=>theme.colors.primaryLight},
${({theme})=>theme.colors.secondaryLight}
);


color:${({theme})=>theme.colors.primary};


font-size:2rem;


margin-bottom:1.5rem;


`;




const CardTitle = styled.h3`

font-size:1.35rem;


font-weight:800;


line-height:1.3;


color:${({theme})=>theme.colors.textDark};


margin-bottom:.8rem;


`;




const CardDescription = styled.p`

font-size:.98rem;


line-height:1.75;


color:${({theme})=>theme.colors.textMuted};


strong{

color:${({theme})=>theme.colors.textDark};

font-weight:700;

}


`;




const LicenseBadge = styled.div`

display:flex;

align-items:center;

gap:8px;


margin-top:1.2rem;


padding:.55rem .9rem;


width:max-content;


background:${({theme})=>theme.colors.primaryLight};


border:1px solid rgba(15,139,66,.2);


color:${({theme})=>theme.colors.primary};


border-radius:50px;


font-size:.78rem;


font-weight:800;


`;





export default function WhyChooseUs(){


const points=[


{

icon:<FiFileText/>,

title:"Licensed & Compliant",

description:
"Fully certified under Sharjah Economic Development Department. We follow UAE regulations, safety standards, and professional contracting practices.",

licenseTag:"SEDD License No. 945516"

},


{

icon:<FiUsers/>,

title:"Skilled Craftsmen",

description:
"Our experienced teams specialize in marble, porcelain slabs, advanced plastering, and detailed finishing techniques ensuring long-lasting results.",

licenseTag:null

},


{

icon:<FiAward/>,

title:"Premium Quality Materials",

description:
"We use trusted UAE suppliers for high-performance adhesives, waterproofing systems, screeds, and premium finishing materials.",

licenseTag:null

}


];




return(


<SectionWrapper id="why-choose-us">


<Container>



<HeaderContainer>


<SectionBadge>

<FiCheckCircle/>

Our Commitment

</SectionBadge>



<SectionTitle>

Why Choose Jisr Al Sahra?

</SectionTitle>



<SectionSubtitle>

Building trust through licensed operations, skilled workmanship, and premium-quality finishing solutions across Sharjah and UAE.

</SectionSubtitle>


</HeaderContainer>





<Grid>


{

points.map((point,index)=>(


<FeatureCard

key={index}

style={{

animationDelay:`${index*0.15}s`

}}

>


<IconWrapper>

{point.icon}

</IconWrapper>



<CardTitle>

{point.title}

</CardTitle>



<CardDescription>

{point.description}

</CardDescription>



{

point.licenseTag &&

<LicenseBadge>

<FiCheckCircle/>

{point.licenseTag}

</LicenseBadge>

}



</FeatureCard>


))


}


</Grid>



</Container>


</SectionWrapper>


);


}
